export interface MembershipIdentity {
  principalId: string;
  label: string;
  identifier: string;
  unavailable: boolean;
}

function actualId(value: unknown): string {
  return typeof value === 'string' && value.trim() && !['undefined', 'null'].includes(value.trim()) ? value : '';
}

/** Resolve identity only from explicit bindings and user records already visible to this account. */
export function membershipIdentity(binding: any, users: any[] = []): MembershipIdentity {
  const explicit = [binding.principalId, binding.userPrincipalId, binding.groupPrincipalId,
    binding.principalName, binding.userPrincipalName, binding.groupPrincipalName].map(actualId).find(Boolean);

  if (explicit) {
    return {
      principalId: explicit, label: '', identifier: explicit, unavailable: false
    };
  }

  const references = [binding.userId, binding.userName].map(actualId).filter(Boolean);
  const exact = users.find((user) => references.some((reference) => [user.id, user.metadata?.name].map(actualId).includes(reference)));
  const usernameMatches = exact ? [] : users.filter((user) => references.includes(actualId(user.username)));
  const user = exact || (usernameMatches.length === 1 ? usernameMatches[0] : null);

  if (user) {
    const principalId = (user.principalIds || []).map(actualId).find(Boolean) || '';

    return {
      principalId,
      label:       user.displayName || user.nameDisplay || user.username || user.id || user.metadata?.name || '',
      identifier:  user.id || user.metadata?.name || user.username || references[0],
      unavailable: false,
    };
  }

  return {
    principalId: '',
    label:       '',
    identifier:  references[0] || actualId(binding.groupId) || actualId(binding.groupName) || actualId(binding.id),
    unavailable: true,
  };
}
